import { Component, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

import { Storage, ref, uploadString, percentage, uploadBytesResumable, UploadTask } from '@angular/fire/storage';

import { ObjectService } from '../../_services/index';

import { environment } from '../../../environments/environment';

@Component({
    selector: 'ngx-object-edit-modal',
    templateUrl: 'object-edit-modal.component.html',
    styleUrls: ['object-edit-modal.component.scss'],
    standalone: false
})
export class ObjectEditModalComponent {

  originalModel;

  _model;
  istemplate = false
  customObject
  @Input() set model(model){
    this._model = {...model};
    this.istemplate = model.collectionPath.includes('template')
    this.originalModel = model;
  };

  @Input() languages;
  @Input() type;
  @Input() game;

  currentObjectImage;
  task:any;
  progress: any;  // Observable 0 to 100
  progressMap = {};

  constructor(protected ref: NbDialogRef<ObjectEditModalComponent>,
    public objectService: ObjectService,
    private storage: Storage) {}

  async handleFileUpdated(objectImage, lang){
    console.log('New object image is:'+objectImage);
    this.currentObjectImage = objectImage;
    await this.saveObjectImage(lang);
  }

  async saveObjectImage(lang){
    
    const filePath = this._model.collectionPath; //`games/${this._model.gameId}/objects/`;
    let fileName = `/${this._model.id}${lang ? '_'+lang : ''}.jpg`;

    let uploadRef = ref(this.storage, filePath+fileName);
    //let task:any = uploadString(uploadRef, this.currentObjectImage, 'data_url');
    let blob = await (await fetch(this.currentObjectImage)).blob();
    console.log('Blob:'+blob);
    let task:any = uploadBytesResumable(uploadRef, blob);

    task.then(async () => {
      const url = 'https://storage.googleapis.com/'+environment.firebase.storageBucket+'/'+filePath+fileName;
      console.log('file uploaded to:'+url);
      if(!lang){
        this._model.pictureUrl = url;
        this._model.filePath = filePath+fileName;
        this._model.pictureLastUpdate = new Date().getTime();
        await this.objectService.updateObject(this._model, {pictureUrl:this._model.pictureUrl, filePath:this._model.filePath, pictureLastUpdate: this._model.pictureLastUpdate});
      }
      else{
        this._model.objectPic[lang] = {filePath:filePath+fileName,url:url,lastUpdateDate:new Date().getTime()};
        await this.objectService.updateObject(this._model, {objectPic:this._model.objectPic});
      }
      setTimeout(() => {
        delete this.progressMap['OBJECT'+(lang ? lang : '')];
      }, 1000);
    });

    // Percentage observer
    percentage(task).subscribe((percentage) => {
      this.progressMap['OBJECT'+(lang ? lang : '')] =  Math.round(percentage.progress);
    });
  }

  cancel() {
    this.ref.close();
  }
  deletePicture(lang){
    if(!lang) this._model.pictureUrl = ''
    else {
      this._model.objectPic[lang] = {}
    }
  }

  async save() {
    //this.originalModel = this._model;
    //Object.assign(this.originalModel, this._model);
    console.log('Save object:'+JSON.stringify(this._model));
    if(this._model.id){
      await this.objectService.updateObject(this._model, {...this._model});
    }
    else{
      console.log('create object:'+this._model.collectionPath);
      if(this._model.collectionPath.indexOf('games/')>=0){
        this._model.scope = 'game';
      }
      await this.objectService.addObject(this._model); 
    }
    this.ref.close(this.originalModel);
  }
}
